import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './PrivateLayout.scss';
// import Sidebar from '../../../../Components/Sidebar/Sidebar';
import Navbar from '../../../../Components/Navbar/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { closeAccessLoader } from '../../../Slice/ProfileSlice';
import { store } from '../../../../Redux/Store';
import Service from '../../../../Features/Patient/Dashboard/services/Service';
import { userlogout, acquireLogoutLock } from '../../../Slice/AuthSlice';
import { motion, AnimatePresence } from 'framer-motion';

const PrivateLayout = () => {
  const isSidebarOpen = useSelector((state) => state.user.isSidebar);
  const isloaderOpen = useSelector((state) => state.user.loader);
  const { user, role } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (role !== 'user') return;

    let cancelled = false;
    const checkAccess = async () => {
      store.dispatch(closeAccessLoader(true));
      if (!user) {
        navigate('/');
        return;
      }

      try {
        const res = await Service.getAcces(user.email);
        if (cancelled) return;
        store.dispatch(closeAccessLoader(false));

        const isAnyOrderValid = res?.data?.orders?.some((order) => {
          const orderType = order.db_order?.type;
          const isMailmanOrBoth = Array.isArray(orderType) ? orderType.includes('mailman') : orderType === 'mailman';
          return isMailmanOrBoth ? order.is_voucher_used : true;
        });

        if (!isAnyOrderValid) {
          if (acquireLogoutLock()) {
            dispatch(userlogout());
            navigate('/');
          }
        }
      } catch (err) {
        if (cancelled) return;
        console.error('API Error:', err);
        store.dispatch(closeAccessLoader(false));
        // Only logout on access errors, not on network/server errors during logout
        if (err?.response?.status === 403) {
          if (acquireLogoutLock()) {
            dispatch(userlogout());
            navigate('/');
          }
        }
      }
    };

    checkAccess();
    return () => {
      cancelled = true;
    };
  }, [user?.email, role]); // eslint-disable-line react-hooks/exhaustive-deps

  // Routes where Sidebar/Navbar should be hidden
  const hideLayoutList = ['/subscriptions'];
  const hideLayout = hideLayoutList.includes(location.pathname);

  return (
    <AnimatePresence mode="wait">
      {!isloaderOpen ? (
        <motion.div
          key="content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          // className={`page-wrapper ${!isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}
          className={`page-wrapper`}
        >
          {/* {!hideLayout && <Sidebar />} */}
          <div className="main-content">
            {!hideLayout && <Navbar isSidebarOpen={!isSidebarOpen} />}

            <div className="inner_page">
              <Outlet />
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          key="loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="access-loader-container"
        >
          <div className="loader"></div>
          <p className="loader-text">Checking access...</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PrivateLayout;
